import { Icon } from '@chakra-ui/react';

export const PhoneIcon = (props: any) => (
  <Icon aria-label="phone icon" viewBox="1 1 16 16" {...props}>
    <path
      d="m12 .75h-6c-1.245 0-2.25 1.005-2.25 2.25v12c0 1.245 1.005 2.25 2.25 2.25h6c1.245 0 2.25-1.005 2.25-2.25v-12c0-1.245-1.005-2.25-2.25-2.25zm-1.5 15h-3v-.75h3zm2.4375-2.25h-7.875v-10.5h7.875z"
      fill="currentColor"
    />
  </Icon>
);
